import {
  getStateName,
  phoneNumbers,
  PolicyDetails,
  validateState,
} from "shared";

import { Alert, unstable__Button as Button } from "@hagerty/react-components";

import { ListCard } from "../../ListCard";
import styles from "./CoveragesListCard.module.scss";
import { useUrls } from "../../../app/Providers/AppContext";
import { TagAction } from "../../../types/Tag.types";
import { Link } from "../../Link";
import { mt } from "../../../utils/tracking";

export type CoveragesListCardProps = {
  policy: PolicyDetails;
};

const editCoveragesTagAction: TagAction = {
  actionName: "Edit coverages",
  actionType: "button",
};

const AlertDesc = () => (
  <>
    This doesn't cover damages while on the road. To modify or add coverages,
    please contact Hagerty's Member Service Center at{" "}
    <Link className={styles.phoneLink} phoneNumber={phoneNumbers.auto}>
      {phoneNumbers.auto}
    </Link>
    .
  </>
);

export const CoveragesListCard = ({ policy }: CoveragesListCardProps) => {
  const urls = useUrls();
  const { policyCoverages, stateRegion, country, hasIdCard, compOnlyType } =
    policy;

  return (
    <ListCard>
      <ListCard.Header>Policy Coverages</ListCard.Header>
      <ListCard.ExpandableRows
        maxRowCount={5}
        viewRowsLabel="View coverages"
        hideRowsLabel="Hide coverages"
        hasFooter={hasIdCard}
      >
        {!hasIdCard && compOnlyType !== "EXCESS_TPL" && (
          <Alert
            classNames={styles.compOnlyAlert}
            alertType="info"
            headingText={`You only have Comprehensive coverage for your
              ${getStateName(validateState(stateRegion))} policy.`}
            messageText={<AlertDesc />}
          />
        )}
        {policyCoverages.map(({ name, limit }, index) => (
          <ListCard.Row key={index}>
            <div className={styles.row}>
              <div className={styles.name}>{name}</div>
              <div className={styles.value}>{limit}</div>
            </div>
          </ListCard.Row>
        ))}
      </ListCard.ExpandableRows>

      {hasIdCard && (
        <ListCard.Footer>
          <Button
            variant="outline"
            color="blueberry"
            size="small"
            className={styles.editCoveragesButton}
            aria-label="Edit coverages"
            href={urls.insurance.editCoverages(country)}
            onClick={() => mt.trackAction(editCoveragesTagAction)}
          >
            Edit coverages
          </Button>
        </ListCard.Footer>
      )}
    </ListCard>
  );
};
